import { cx } from '../../lib/cx';
import type { SidebarProps } from '../types';

/**
 * Left navigation: brand on top, grouped links, something pinned at the bottom. 240 px wide,
 * white, one thin border. Which entry is active comes from the current path.
 */
export const Sidebar = ({ brand, sections, currentPath, renderLink, footer }: SidebarProps) => (
  <aside className="flex h-full w-60 flex-col border-r border-gray-200 bg-white">
    <div className="flex h-16 items-center border-b border-gray-200 px-5">{brand}</div>
    <nav aria-label="Principal" className="flex-1 overflow-y-auto px-3 py-4">
      {sections.map((section, index) => (
        <div key={section.title ?? index} className={cx(index > 0 && 'mt-5')}>
          {section.title ? (
            <p className="mb-1 px-3 text-xs font-semibold uppercase tracking-wide text-gray-400">
              {section.title}
            </p>
          ) : null}
          <ul className="space-y-0.5">
            {section.items.map((item) => {
              const active =
                item.href === '/' ? currentPath === '/' : currentPath.startsWith(item.href);
              return (
                <li key={item.href}>
                  {renderLink(
                    item,
                    cx(
                      'flex items-center gap-3 rounded-control px-3 py-2 text-sm font-medium transition-colors',
                      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500',
                      active
                        ? 'bg-brand-50 text-brand-700'
                        : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900',
                    ),
                    active,
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </nav>
    {footer ? <div className="border-t border-gray-200 p-3">{footer}</div> : null}
  </aside>
);
